import { render, staticRenderFns } from "./Asignacion_corporacion_v2.vue?vue&type=template&id=465ff89e"
import script from "./Asignacion_corporacion_v2.vue?vue&type=script&lang=js"
export * from "./Asignacion_corporacion_v2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports